import React from 'react';
import PropTypes from 'prop-types';
import Box from '@quintoandar/cozy-core/Box';
import Skeleton from '@quintoandar/cozy-core/Skeleton';
import DropUpload from 'components/UploadImage/DropMultiUploader';

export const OnLoadingUpload = ({
  galleryType,
  houseType,
  houseId,
  hasNotDataUploadedBeenRetrived,
  hasNotInitialDataBeenRetrived,
  hasStartedUpdloadPhoto,
}) => {
  if (hasNotDataUploadedBeenRetrived || hasNotInitialDataBeenRetrived || hasStartedUpdloadPhoto) {
    return (
      <Box mt={3}>
        <Skeleton width="100%" height="194px" />
      </Box>
    );
  }
  return (
    <Box mt={3}>
      <DropUpload houseType={houseType} houseId={houseId} galleryType={galleryType} />
    </Box>
  );
};

OnLoadingUpload.propTypes = {
  galleryType: PropTypes.string.isRequired,
  houseId: PropTypes.string.isRequired,
  houseType: PropTypes.string.isRequired,
  hasNotDataUploadedBeenRetrived: PropTypes.bool.isRequired,
  hasNotInitialDataBeenRetrived: PropTypes.bool.isRequired,
  hasStartedUpdloadPhoto: PropTypes.bool.isRequired,
};

export default OnLoadingUpload;
